export const DEFAULT_TZ = "America/Toronto";

const opts = (tz, o) => ({ timeZone: tz || DEFAULT_TZ, ...o });

export const fmtTime = (iso, tz) =>
  new Intl.DateTimeFormat("fr-CA", opts(tz, { hour: "2-digit", minute: "2-digit" })).format(new Date(iso));

export const fmtDay = (iso, tz) =>
  new Intl.DateTimeFormat("fr-CA", opts(tz, { weekday: "long", day: "numeric", month: "long" })).format(new Date(iso));

export const fmtDateTime = (iso, tz) =>
  new Intl.DateTimeFormat("fr-CA", opts(tz, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })).format(new Date(iso));

export const fmtShortDate = (iso, tz) =>
  new Intl.DateTimeFormat("fr-CA", opts(tz, { day: "numeric", month: "long", year: "numeric" })).format(new Date(iso));

export function todayKey(tz = DEFAULT_TZ) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}

export function shiftKey(key, days) {
  const d = new Date(`${key}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function keyLabel(key) {
  const today = todayKey();
  if (key === today) return "Aujourd'hui";
  if (key === shiftKey(today, 1)) return "Demain";
  if (key === shiftKey(today, -1)) return "Hier";
  return new Intl.DateTimeFormat("fr-CA", { timeZone: "UTC", weekday: "short", day: "numeric", month: "short" }).format(new Date(`${key}T12:00:00Z`));
}

export const STATUS_LABEL = {
  scheduled: "À venir",
  live: "En direct",
  final: "Terminé",
  postponed: "Reporté",
  cancelled: "Annulé",
};

export const tzLabel = (tz) => (tz === "America/Toronto" ? "Québec (heure de l'Est)" : tz);
